import { render } from "./message-merger.vue?vue&type=template&id=235bdc1e&scoped=true&ts=true"
import script from "./message-merger.vue?vue&type=script&lang=ts"
export * from "./message-merger.vue?vue&type=script&lang=ts"

import "./message-merger.vue?vue&type=style&index=0&id=235bdc1e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235bdc1e"]])

export default __exports__